import { storeAsync } from '@/app-module';
import Permissions from '@/security/permissions';

const Layout = () => import('@/modules/layout/components/layout');
const RealEstateRegister = () => import('@/modules/real-estate-register/components/RealEstateRegister.vue');

const getRealEstateRegisterModule = () => import('@/modules/real-estate-register/real-estate-register-store');

const importRealEstateRegisterStore = () =>
    getRealEstateRegisterModule().then(async (storeModule) => {
        if (!storeAsync().hasModule('realEstateRegister')) await storeAsync().registerModule('realEstateRegister', storeModule.default);
        else return;
    });

const getApplicationsModule = () => import('@/modules/applications/applications-store');
const importApplicationsStore = () =>
    getApplicationsModule().then(async (storeModule) => {
        if (!storeAsync().hasModule('applications')) await storeAsync().registerModule('applications', storeModule.default);
        else return;
    });


export default [
    {
        path: '',
        exact: true,
        component: Layout,
        meta: { auth: true },
        children: [
            {
                name: 'real-estate-register',
                path: '/real-estate-register',
                component: RealEstateRegister,
                exact: true,
                meta: { 
                    auth: true,
                    permission: Permissions.values.realEstateRegisterRead,
                    breadcrumb: 'REAL_ESTATE_REGISTER.TITLE'
                },
                beforeEnter: (to, from, next) => {
                    importRealEstateRegisterStore().then(() => {
                        importApplicationsStore().then(() => {
                            next();
                        });
                    });
                }
            }
        ]
    }
];
